import React from 'react';
import { connect } from 'react-redux';

class OfferInfoCartData extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { offerInfoCartData = [] } = this.props;
    if (offerInfoCartData && offerInfoCartData.length > 0) {
      return (
        <div className="plp-promo-block">
          <div className="ic-offer-tag" />
          <div className="promo-blck">
            <div className="promo-desc-block">
              {offerInfoCartData.map(item => {
                let { offerInfocontent } = item;
                return <div className="plp-promo-desc" aria-label={item.offerInfocontent}>{item.offerInfocontent}</div>;
              })}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
const mapStatetoProps = state => {
  const { productsAdditionalInfo = {} } = state;
  const { offerInfoCartData = [] } = productsAdditionalInfo;
  return {
    offerInfoCartData
  };
};
export default connect(mapStatetoProps)(OfferInfoCartData);
